import React from 'react';
import './Loading.css';

/**
 * Unified Loading Component
 * Renders a crisp, accessible, theme-responsive loading spinner.
 * Automatically adopts the active theme palette and avoids duplicate/heavy animations.
 * 
 * @param {string} size - Size of the spinner: 'small', 'medium', 'large' (default: 'medium')
 * @param {string} message - Optional loading message to display below the spinner
 * @param {boolean} fullScreen - Whether to display as full screen overlay (default: false)
 * @param {string} className - Additional CSS classes
 */
const Loading = ({ 
  size = 'medium', 
  message = null, 
  fullScreen = false,
  className = '',
}) => {
  const sizeMap = {
    small: { dim: 24, borderWidth: 3 },
    medium: { dim: 40, borderWidth: 4 },
    large: { dim: 56, borderWidth: 4 }
  };

  const { dim, borderWidth } = sizeMap[size] || sizeMap.medium;
  const containerClass = `loading-container ${fullScreen ? 'loading-fullscreen' : ''} ${className}`.trim();

  return (
    <div className={containerClass} role="status" aria-live="polite">
      <div className="loading-content">
        <div
          className="loading-theme-spinner"
          style={{
            width: `${dim}px`,
            height: `${dim}px`,
            borderWidth: `${borderWidth}px`,
            borderStyle: 'solid',
            borderColor: 'var(--theme-primary, var(--primary-blue, #2563eb))',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
          }}
        />
        {message && (
          <p className="loading-message">{message}</p>
        )}
      </div>
    </div>
  );
};

export default Loading;

